import moment from "moment";
import { formatMoney } from "../../features/utils/formatMoney";
import { getSupplierName } from "../flight/supplier/getSupplierName";
import { getSupplierClass } from "../../components/flight/FlightOfferDisplay";
import { flightStatusMap } from "../../pages/Orders/OrdersData";
import { alertType } from "../constants";
import Icon from "../../components/HOC/Icon";
import { Link } from "react-router-dom";
import {
  getChangeStatusName,
  getStatusName,
} from "../flight/order/getStatusName";
import OrderStatus from "../../components/order/OrderStatus";
import { getFlightFareTypeTagElement } from "./flightFareTypeTag";

export function templateFlightOrderReissueData(data) {
  console.log(data);
  const flightData = data?.flightBooking?.at(0);
  // debugger
  let flightType = "One Way";
  if (flightData?.destinations?.length) {
    flightType = "Multi City";
    if (
      flightData?.destinations?.at(-1)?.to ===
      flightData?.destinations?.at(0)?.from
    )
      flightType = "Return";
  }

  return [
    {
      elements: [
        {
          type: "title",
          value: moment(data?.createdAt)?.format("DD-MM-YYYY HH:mm [GMT]Z"),
        },
        {
          type: "copy",
          value: data?.orderId,
          renderValue: () => (
            <Link
              target="_blank"
              to={
                "/order/flight/ticket/changedate/confirmation/" +
                data?._id +
                "?page=Date Change"
              }
            >
              {data?.orderId}
            </Link>
          ),
        },
        {
          type: "tag",
          value: getSupplierName(flightData?.supplier),
          className: getSupplierClass(flightData?.supplier),
          color: "text-[#BD002A]",
          background: "bg-[#BD002A]/20",
        },
        {
          type: "title",
          value: "",
        },
        getFlightFareTypeTagElement(flightData),
        {
          type: "Agent",
          render: () => (
            <div className="py-2">
              <small>
                {(data?.account?.firstName || "") +
                  " " +
                  (data?.account?.lastName || "")}
              </small>
              <div
                className="w-[200px] overflow-hidden whitespace-nowrap text-ellipsis"
                title={data?.account?.detail?.tradingName}
              >
                {data?.account?.detail?.tradingName}
              </div>
            </div>
          ),
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[25%]",
    },
    {
      elements: [
        { type: "title", value: "Request Time" },
        {
          type: "text",
          value: moment(data?.updatedAt)?.format("YYYY-MM-DD HH:mm"),
        },
      ],
      value: moment(data?.updatedAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[20%]",
    },

    {
      elements: [
        { type: "title", value: flightType },
        {
          type: "text",
          render: () => (
            <div>
              {flightData?.destinations
                ?.slice(0, 1)
                ?.map((obj) => `${obj?.from} - ${obj?.to}`)
                ?.join(",") || ""}
              <div>
                <span className="text-theme1">{flightData?.pnr}</span>
              </div>
              <small>{flightData?.flights?.at(0)?.airlineName}</small>
            </div>
          ),
        },
      ],
      width: "md:w-[15%]",
    },
    {
      elements: [
        { type: "title", value: "Travel Time" },
        {
          type: "text",
          value:
            moment(flightData?.flights?.at(0)?.departureDate)?.format(
              "YYYY-MM-DD",
            ) + " ",
        },
        {
          type: "text",
          value: (
            <span className="text-blue-500">
              {flightData?.flights?.at(0)?.departureTime +
                " - " +
                flightData?.flights?.at(0)?.arrivalTime}
            </span>
          ),
        },
      ],
      value: moment(flightData?.flights?.at(0)?.departureDate)?.format(
        "YYYY-MM-DD",
      ),
      width: "md:w-[15%]",
    },
    {
      elements: [
        { type: "title", value: "GDS PNR" },
        { type: "copy", value: flightData?.pnr },
        { type: "title", value: "Airline PNR" },
        { type: "copy", value: flightData?.pnr },
      ],
      width: "md:w-[15%]",
    },
    {
      elements: [
        { type: "title", value: "Passenger" },
        {
          type: "text",
          value: flightData?.travelers
            ?.map(
              (obj) =>
                `${obj?.firstName} ${obj?.middleName || ""} ${obj?.lastName}`,
            )
            ?.join(", "),
        },
      ],
      width: "md:w-[15%]",
    },
    {
      elements: [
        { type: "title", value: "Fee" },
        {
          type: "text",
          value: data?.payable ? formatMoney(data?.payable) : "-",
        },
      ],
      value: flightData?.payable,
      width: "md:w-[15%]",
    },
    {
      elements: [
        { type: "title", value: "Status" },
        {
          type: "status",
          value: getChangeStatusName(flightStatusMap(data?.status)),
          render: () => {
            const status = flightStatusMap(data?.status);
            const assigned =
              ["Approved", "Pending"]?.includes(status) && data?.tasks?.at(0);
            return (
              <div className={`rounded-md mb-3`}>
                <span
                  className={`inline-block overflow-hidden text-ellipsis text-xs `}
                  title={status}
                >
                  {assigned ? (
                    ["Approved", "Pending"]?.includes(status) ? (
                      !["ToDo"]?.includes(assigned?.taskStatus) ? (
                        `Awaiting Quote by ${assigned?.assignee?.firstName} ${assigned?.assignee?.lastName}`
                      ) : ["ToDo"]?.includes(assigned?.taskStatus) ? (
                        `Awaiting acceptance by ${assigned?.assignee?.firstName} ${assigned?.assignee?.lastName}`
                      ) : (
                        `Assigned to ${assigned?.assignee?.firstName} ${assigned?.assignee?.lastName}`
                      )
                    ) : (
                      `Under Review by ${assigned?.assignee?.firstName} ${assigned?.assignee?.lastName}`
                    )
                  ) : (
                    <OrderStatus value={getChangeStatusName(status, data)} />
                  )}
                </span>
              </div>
            );
          },
        },
        {
          type: "time",
          render: () => {
            const diffInSeconds = moment
              .utc(flightData?.ticketingExpiry)
              .diff(moment.utc(), "seconds");

            // Format the difference in the "5h 10m 5s" format
            const hours = Math.floor(diffInSeconds / 3600);
            const minutes = Math.floor((diffInSeconds % 3600) / 60);
            // const seconds = diffInSeconds % 60;

            return (hours || minutes) > 0 ? (
              <div className="flex gap-1 items-center">
                <Icon icon="mdi:clock-outline" className="!w-4 !h-4" />
                {hours || minutes} {hours ? "Hrs" : "Mins"}
              </div>
            ) : null;
          },
        },
      ],
      value: (function () {
        return ["Pending", "Denied", "Approved", "PendingVoid"]?.findIndex(
          (val) => val === flightStatusMap(data?.status),
        );
      })(),
      width: "md:w-[15%]",
    },
  ];
}

// export enum ORDER_STATUS {
//   Approved = "Approved",
//   Paid = "Paid",
//   Denied = "Denied",
//   Pending = "Pending",
//   PendingPayment = "PendingPayment",
//   PendingVoid = "PendingVoid",
//   Success = "Success",
//   Failed = "Failed",
//   Closed = "Closed",
// }
